<template>
  <div>
    <div
      class="pull-right"
      :style="{
        marginTop: this.$route.name === 'Respostas' ? '-45px' : '-150px',
      }"
    >
      <div class="switch-box only-comments pt-3 pr-1">
        <b-form-checkbox
          :checked="selectComments"
          @change="handleJustComments($event)"
          switch
        ></b-form-checkbox>
        <span>{{ $t('answers.justCommentsLable') }}</span>
      </div>
    </div>
    <div class="row mt-2 pl-3"><strong>Pesquisar por</strong></div>
    <div class="row">
      <div class="col-12 header-filters mt-2">
        <div class="filters-area">
          <div class="filter-type">
            <b-form-select
              v-model="filterType"
              @change="setFilterType"
              :options="filterTypeOptions"
            ></b-form-select>
          </div>

          <div class="search-answers">
            <input
              type="text"
              class="form-control"
              id="input-answer"
              :placeholder="$t('answers.searchInput')"
              v-model="filter"
              @keyup="searchByFilter"
            />
            <button @click="cleanFilter" class="btn btn-outline-primary">
              {{ $t('answers.searchButton') }}
            </button>
          </div>

          <div class="filters-options-area">
            <div class="ml-3 p-0">
              <b-form-select
                @change="handleFilter"
                v-model="filterSelected"
                :options="filterOptions"
              ></b-form-select>
            </div>
            <div v-if="displayFilterOptions" class="ml-3 p-0">
              <b-form-select
                @change="handleFilterValue"
                v-model="filterValueSelected"
                :options="filterSelectedOptions"
              ></b-form-select>
            </div>
            <div
              v-if="
                filterSelected === 'category' && filterValueSelected !== null
              "
              class="ml-3 p-0"
            >
              <b-form-select
                @change="handleFilterSubCategory"
                v-model="filterSubCategorySelected"
                :options="filterOptionsSubCategory"
              ></b-form-select>
            </div>

            <div
              v-if="
                filterSelected === 'treatmentTags' &&
                filterValueSelected !== null
              "
              class="ml-3 p-0"
            >
              <b-form-select
                @change="handleFilterSubTag"
                v-model="filterSubTagSelected"
                :options="filterOptionsSubTag"
              ></b-form-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- seletores de filtros pergunta adicional -->
    <div class="row mt-3 ml-2" v-if="filterSelected === 'typeAddQuestion' && filterValueSelected !== null">
      <strong><p>Filtro por pergunta adicional</p></strong>
     </div>
    <div class="row">
      <div
        v-if="
          filterSelected === 'typeAddQuestion' && filterValueSelected !== null
        "
        class="ml-3 p-0 addquestion-select"
      >
        <b-form-select
          @change="getOptionsFilterByQuestionType"
          v-model="addQuestionSelected"
          :options="listAddQuestionsOptions"
        ></b-form-select>
      </div>
      <div
        v-if="
          filterValueSelected &&
          filterSelected === 'typeAddQuestion' &&
          filterValueSelected !== 'MULTIPLE'
        "
        style="width: 20%"
      >
        <b-form-select
          @change="applyFiltersUrlConditional"
          v-model="conditionalSelected"
          :options="listConditionals"
          style="margin-left: 20px"
        ></b-form-select>
      </div>
      <div
        v-if="
          filterValueSelected &&
          filterSelected === 'typeAddQuestion' &&
          filterValueSelected !== 'MULTIPLE'
        "
        style="width: 25%"
      >
        <b-form-select
          @change="applyFiltersUrlGrade"
          v-model="gradeSelected"
          :options="listGrades"
          style="margin-left: 35px"
        ></b-form-select>
      </div>
      <div
        style="margin-left: 18px; width: 22%"
        v-if="
          filterValueSelected &&
          filterValueSelected === 'MULTIPLE' &&
          addQuestionSelected
        "
      >
        <b-form-select
          @change="getSubOptions(optionSelected)"
          v-model="optionSelected"
          :options="listOptionsMultipleChoice"
        ></b-form-select>
      </div>
      <div
        style="margin-left: 18px; width: 22%"
        v-if="
          filterValueSelected &&
          filterValueSelected === 'MULTIPLE' &&
          addQuestionSelected &&
          optionSelected
        "
      >
        <b-form-select
          @change="applyFiltersUrlGrade"
          v-model="subOptionSelected"
          :options="listSubOptionsMultipleChoice"
        ></b-form-select>
      </div>
    </div>
    <!-- fim -->

    <div class="row mt-3">
      <div class="col-12 filters-area">
        <div v-if="this.profileSelect.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.profile') }}:
            {{ this.profileSelect.text }}
          </span>
          <span @click="removeFilter('profile')" class="remove">&times;</span>
        </div>
        <div v-if="this.statusSelect.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.status') }}:
            {{ this.statusSelect.text }}
          </span>
          <span @click="removeFilter('status')" class="remove">&times;</span>
        </div>
        <div v-if="lastContactStatus.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.status') }}:
            {{ this.lastContactStatus.text }}
          </span>
          <span @click="removeFilter('lastStatus')" class="remove"
            >&times;</span
          >
        </div>
        <div v-if="this.categorySelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.category') }}:
            {{ this.categorySelected.text }}
          </span>
          <span @click="removeFilter('category')" class="remove">&times;</span>
        </div>
        <div v-if="this.notificationSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.notification') }}:
            {{ this.notificationSelected.text }}
          </span>
          <span @click="removeFilter('notification')" class="remove">
            &times;
          </span>
        </div>
        <div v-if="audioSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.audio') }}:
            {{ audioSelected.text }}
          </span>
          <span @click="removeFilter('audio')" class="remove"> &times; </span>
        </div>
        <div v-if="partialAnswerSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.partial') }}:
            {{ partialAnswerSelected.text }}
          </span>
          <span @click="removeFilter('partialAnswer')" class="remove"> &times; </span>
        </div>
        <div v-if="recordedAudioSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.recordedAudio') }}:
            {{ recordedAudioSelected.text }}
          </span>
          <span @click="removeFilter('recordedAudio')" class="remove"> &times; </span>
        </div>
        <div v-if="sentimentSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.sentiment') }}:
            {{ sentimentSelected.text }}
          </span>
          <span @click="removeFilter('sentiment')" class="remove"> &times; </span>
        </div>
        <div v-if="this.channelSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.channel') }}:
            {{ this.channelSelected.text }}
          </span>
          <span @click="removeFilter('channel')" class="remove"> &times; </span>
        </div>
        <div v-if="this.subCategorySelected.value" class="tag">
          <span>
            SubCategoria:
            {{ this.subCategorySelected.text }}
          </span>
          <span @click="removeFilter('subCategory')" class="remove"
            >&times;</span
          >
        </div>
        <div v-if="this.responsibleSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.responsible') }}:
            {{ this.responsibleSelected.text }}
          </span>
          <span @click="removeFilter('responsible')" class="remove"
            >&times;</span
          >
        </div>
        <div v-if="this.commentSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.comments') }}:
            {{ this.commentSelected.text }}
          </span>
          <span @click="removeFilter('comment')" class="remove"> &times; </span>
        </div>
        <div v-if="this.anonymousSelected.value" class="tag">
          <span>
            {{ this.$t('answers.filterOptions.anonymous') }}:
            {{ this.anonymousSelected.text }}
          </span>
          <span @click="removeFilter('anonymous')" class="remove">
            &times;
          </span>
        </div>
        <div v-if="this.tagSelected.value" class="tag">
          <span>
            Tag:
            {{ this.tagSelected.text }}
          </span>
          <span @click="removeFilter('tag')" class="remove"> &times; </span>
        </div>
        <div v-if="subTagSelected.value" class="tag">
          <span>
            SubTag:
            {{ subTagSelected.text }}
          </span>
          <span @click="removeFilter('subTag')" class="remove">&times;</span>
        </div>
        <div v-if="tagFilterAddQuestion.value" class="tag">
          <span id="filter-addquestion">
            {{ returnNameWithEllipsis(tagFilterAddQuestion.text) }}
          </span>
          <span
            @click="removeFilter('typeAddQuestion-conditional-grade')"
            class="remove"
            >&times;</span
          >
          <b-tooltip target="filter-addquestion" triggers="hover">
            {{ tagFilterAddQuestion.text }}
          </b-tooltip>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-table
          striped
          @sort-changed="sortingChanged"
          no-local-sorting
          id="treatment-table"
          class="mt-3"
          :items="answer"
          :fields="fields"
          :busy="$store.state.treatments.loading"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
          </template>
          <!-- Data -->
          <template v-slot:cell(date)="row">
            {{ dateFormat(new Date(row.item.date)) }}
          </template>
          <!-- Nota -->
          <template v-slot:cell(review)="row">
            <template v-if="row.item.metric === 'like-dislike'">
              <span v-if="row.item.review === 1">
                <img
                  alt="Like"
                  width="60"
                  height="60"
                  src="../../../assets/Like.svg"
                />
              </span>
              <span v-if="row.item.review === 0">
                <img
                  alt="Deslike"
                  width="60"
                  height="60"
                  class="thumbs-down-answer"
                  src="../../../assets/Deslike.svg"
                />
              </span>
            </template>
            <template v-else>
              <div
                :class="`flag-grade flag-grade-${gradeFormat(row.item.review)}`"
              >
                <span v-if="row.item.review != '99'">{{
                  row.item.review
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </template>
          <!-- Cliente -->
          <template v-slot:cell(name)="row">
            <span class="user-info">
              {{ checkName(row.item.anonymousResponse, row.item.name) }}</span
            >
            <br />
            <span class="user-info">
              {{ $t('answers.email') }}:
              {{
                checkUserData(
                  row.item.anonymousResponse,
                  userProfile.permissions.answers.anonymous_profile,
                  row.item.email,
                )
              }}
            </span>
            <br />
            <span class="user-info">
              {{ $t('answers.telephone') }}:
              {{
                checkUserData(
                  row.item.anonymousResponse,
                  userProfile.permissions.answers.anonymous_profile,
                  row.item.phone,
                )
              }}
            </span>
            <br />
            <span class="user-info"
              >{{ $t('answers.channel') }}: {{ row.item.channel }}</span
            >
            <br />
            <span class="user-info"
              >{{ $t('answers.action') }}: {{ row.item.actionId.name }}</span
            >
            <br />
            <span class="user-info">
              {{ $t('answers.metric') }}:
              {{
                row.item.metric === 'nps-0-10'
                  ? 'NPS 0 a 10'
                  : row.item.metric === 'nps-1-5'
                  ? 'NPS 1 a 5'
                  : row.item.metric === 'ces-1-5'
                  ? 'CES 1 a 5'
                  : row.item.metric === 'csat-1-5'
                  ? 'CSAT 1 a 5 (Top 2 box)'
                  : row.item.metric === 'csat-1-5(media)'
                  ? 'CSAT 1 a 5 (Média)'
                  : row.item.metric === 'csat-0-10(media)'
                  ? 'CSAT 0 a 10 (Média)'
                  : row.item.metric === '5-stars'
                  ? '5-Stars'
                  : 'Like/Dislike - 0 e 1'
              }}
            </span>
          </template>
          <!-- Comment -->
          <template v-slot:cell(comment)="row" style="min-width: 220px">
            <div v-if="row.item.feedbackEdited.edition">
              {{ showComment(row.item.feedbackEdited.edition) }}
              <span>
                <i
                  class="fas fa-pen ml-1"
                  style="font-size: 12px; color: #c1c1c1"
                  :title="`${$t('answers.feedbackEdited', {
                    feedbackEditedAutor: `${row.item.feedbackEdited.author}`,
                  })}`"
                ></i>
              </span>
            </div>
            <div v-else>
              {{
                row.item.translatedFeedback
                  ? row.item.translatedFeedback
                  : showComment(row.item.feedback)
              }}
              <div
                class="translate"
                v-if="row.item.feedback && company.enableTranslateFeedback"
              >
                <img
                  :id="`popover-reactive-${row.item._id}`"
                  src="../../../assets/translate.png"
                  alt=""
                />
              </div>
              <b-popover
                :target="`popover-reactive-${row.item._id}`"
                triggers="hover"
                placement="auto"
                container="my-container"
                ref="popover"
              >
                <template #title> Traduzir para: </template>
                <div>
                  <b-spinner
                    style="position: absolute; top: 10px; right: 8px"
                    v-if="isLoadingTranslate"
                    small
                    class="pull-right"
                    variant="primary"
                  ></b-spinner>
                  <div
                    v-for="item in translations"
                    class="translate-list-item"
                    @click="
                      translate(row.item.feedback, item.target, row.index)
                    "
                  >
                    {{ item.label }}
                  </div>
                </div>
              </b-popover>
            </div>
            <b-modal
              :id="`modal-comment-${row.index}`"
              :title="`${$t('answers.editComment')}`"
              @ok="editComment(row.item, row.index)"
            >
              <p>
                <small>
                  {{ $t('answers.editComentary') }}
                </small>
              </p>
              <textarea
                class="form-control"
                :value="
                  row.item.feedbackEdited.edition
                    ? row.item.feedbackEdited.edition
                    : row.item.feedback
                "
                :id="`comment-feedback-eddited-${row.index}`"
                rows="8"
              ></textarea>
            </b-modal>
            <div class="text-left" v-if="row.item.audioResponseUrl">
              <audio :src="row.item.audioResponseUrl" controls style="height: 30px; width: 90%;"></audio>
            </div>
          </template>
          <!-- Responsável -->
          <template v-slot:cell(responsible)="row">
            <span v-if="row.item.treatments.responsible !== 'none'">
              {{
                row.item.treatments.responsible
                  ? row.item.treatments.responsible.name
                  : 'Ninguém'
              }}
            </span>
            <span v-else>{{ $t('answers.nobody') }}</span>
          </template>
          <!-- Categorias -->
          <template v-slot:cell(category)="row" :id="row.index">
            <div class="categories-area">
              <div
                v-for="(category, i) in row.item.categories"
                :key="i"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <idx-chips :categoryIA="isCategoryIA(row.index, category._id)">
                  <span>{{ category.name }}</span>
                  <span
                    v-if="userProfile.permissions.treatments.category"
                    class="closebtn"
                    @click="handleRemoveCategory(row.index, category._id, i)"
                    >&times;</span
                  >
                </idx-chips>

                <template
                  v-for="(subCategory, index) in row.item.subCategories"
                >
                  <idx-chips
                    :subCategoryIA="isSubCategoryIA(row.index, subCategory._id)"
                    v-if="subCategory.mainCategoryId === category._id"
                    :key="index"
                    :subCategory="true"
                    style="margin-left: 24px"
                  >
                    <span>{{ subCategory.name }}</span>
                    <span
                      v-if="userProfile.permissions.treatments.category"
                      class="closebtn"
                      @click="
                        handleRemoveSubCategory(
                          row.index,
                          category._id,
                          subCategory._id,
                          index,
                        )
                      "
                      >&times;</span
                    >
                  </idx-chips>
                </template>
              </div>
            </div>

            <span v-if="userProfile.permissions.treatments.category">
              <dropdown-categories
                :id-item="`${row.item._id}`"
                :categories="row.item.categories"
                :categoryGroupId="row.item.actionId.categoryGroupId"
                :myAnswer="row.item"
                :subCategory="row.item.subCategories"
              />
            </span>
          </template>
          <!-- Tags -->
          <template v-slot:cell(tags)="row">
            <div class="categories-area">
              <div
                v-for="(tag, i) in row.item.tags"
                :key="i"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <idx-chips style="background: #ff8ada">
                  <span>{{ tag.name }}</span>
                </idx-chips>

                <template v-for="(subTag, index) in row.item.subTags">
                  <idx-chips
                    v-if="subTag.mainTagId === tag._id"
                    :key="index"
                    :subCategory="true"
                    style="margin-left: 24px; background: #7ab4f2"
                  >
                    <span>{{ subTag.name }}</span>
                  </idx-chips>
                </template>
              </div>
            </div>
          </template>

          <!-- Status -->
          <template
            v-if="!isAnswerMenu && userProfile.permissions.treatments.status"
            v-slot:cell(status)="row"
          >
            <dropdown-status
              :currentStatus="row.item.treatments.status"
              :idItem="row.item._id"
              :resurveyId="row.item.actionId.resurveyId"
              :review="row.item.review"
            />
            <div v-if="row.item.treatments.emailReceived">
              <font-awesome-icon
                :class="
                  row.item.treatments.viewedEmail
                    ? 'text-secondary'
                    : 'text-primary'
                "
                style="font-size: 20px; margin-left: 45px"
                :title="
                  row.item.treatments.viewedEmail
                    ? `${$t('treatments.userReplyTratativa')}`
                    : `${$t('treatments.unreadTratativa')}`
                "
                :icon="
                  row.item.treatments.viewedEmail
                    ? ['fa', 'envelope-open-text']
                    : ['fa', 'envelope']
                "
              />
            </div>
          </template>
          <!-- Detalhes -->
          <template v-if="!isAnswerMenu" v-slot:cell(days)="row">
            {{ showDays(row.item) }}
          </template>
          <!-- Detalhes -->
          <template v-if="isAnswerMenu" v-slot:cell(details)="row">
            <div class="table-icons" style="min-width: 170px">
              <span
                style="cursor: pointer"
                class="mr-2"
                :title="`${$t('answers.addQuestions')}`"
                @click="loadCustomer(row.item._id)"
              >
                <b-spinner
                  small
                  :id="`spinner_${row.item._id}`"
                  style="display: none; width: 1.3rem; height: 1.3rem"
                ></b-spinner>
                <font-awesome-icon
                  :id="`icon_${row.item._id}`"
                  :icon="['fa', 'list']"
                />
              </span>

              <a
                v-if="userProfile.permissions.answers.edit_feedback"
                class="mr-2"
                :title="`${$t('answers.editComment')}`"
                v-b-modal="`modal-comment-${row.index}`"
              >
                <font-awesome-icon :icon="['fa', 'edit']" />
              </a>

              <router-link
                :to="`/treatments/${row.item._id}`"
                class="mr-2"
                :title="`${$t('answers.details')}`"
              >
                <font-awesome-icon :icon="['fa', 'comments']" />
              </router-link>
              <a
                v-if="userProfile.permissions.answers.delete"
                @click="deleteAnswer(row.item._id, row.item.actionId._id)"
                :title="`${$t('answers.removeAnswer')}`"
              >
                <font-awesome-icon :icon="['fa', 'trash-alt']" />
              </a>
            </div>
          </template>
          <template v-else v-slot:cell(details)="row">
            <div class="table-icons">
              <router-link
                v-if="userProfile.permissions.treatments.details"
                :to="`/treatments/${row.item._id}`"
              >
                <font-awesome-icon :icon="['fas', 'search']" />
              </router-link>

              <a
                v-if="userProfile.permissions.answers.delete"
                @click="deleteAnswer(row.item._id, row.item.actionId._id)"
                :title="`${$t('answers.removeAnswer')}`"
              >
                <font-awesome-icon :icon="['fa', 'trash-alt']" />
              </a>
            </div>
          </template>
        </b-table>
        <div class="footer" v-show="!loading">
          <div class="pagination-area-answers">
            <paginate
              v-model="page"
              :pageCount="Math.ceil(summary.total / this.limit)"
              :clickHandler="updateTable"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            ></paginate>
          </div>
          <div class="row mr-2">
            <div class="mr-3">
              <div
                v-if="loadingDownloadIconCsv"
                class="text-center text-primary my-2"
              >
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
              <a v-else :title="$t('answers.exportCsv')">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none dropdown-csv"
                  no-caret
                >
                  <template #button-content>
                    <span class="xls">
                      <i class="fas fa-file-csv"></i>
                    </span>
                  </template>
                  <b-dropdown-item @click="exportData('csv', 'comma', null)">{{
                    $t('answers.csvCommaSeparator')
                  }}</b-dropdown-item>
                  <b-dropdown-item @click="exportData('csv', 'pipe', null)">{{
                    $t('answers.csvPipeSeparator')
                  }}</b-dropdown-item>
                </b-dropdown>
              </a>
            </div>

            <div>
              <div
                v-if="loadingDownloadIconXls"
                class="text-center text-primary my-2"
              >
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
              <div v-else>
                <div v-if="isEnjoeiCompany">
                  <a :title="$t('answers.exportXls')">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none dropdown-csv"
                      no-caret
                    >
                      <template #button-content>
                        <span class="xls">
                          <i class="fas fa-file-excel"></i>
                        </span>
                      </template>
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'categories')"
                        >{{ $t('answers.categoriesDownload') }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'analytics')"
                        >{{ $t('answers.analyticsDownload') }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'answers')"
                        >{{ $t('answers.answersDownload') }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </a>
                </div>
                <div v-else-if="isGolCompany">
                  <a :title="$t('answers.exportXls')">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none dropdown-csv"
                      no-caret
                    >
                      <template #button-content>
                        <span class="xls">
                          <i class="fas fa-file-excel"></i>
                        </span>
                      </template>
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'categories')"
                        >{{ $t('answers.categoriesDownload') }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'analytics')"
                        >{{ $t('answers.analyticsDownload') }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'answers')"
                        >{{ $t('answers.answersDownload') }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </a>
                </div>
                <div v-else-if="isRiachueloCompany">
                  <a :title="$t('answers.exportXls')">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none dropdown-csv"
                      no-caret
                    >
                      <template #button-content>
                        <span class="xls">
                          <i class="fas fa-file-excel"></i>
                        </span>
                      </template>
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'categories')"
                        >{{ $t('answers.categoriesDownload') }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="exportData('xlsx', null, 'answers')"
                        >{{ $t('answers.answersDownload') }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </a>
                </div>
                <div v-else>
                  <a
                    @click="exportData('xlsx', null, null)"
                    :title="$t('answers.exportXls')"
                  >
                    <span class="xls">
                      <i class="fas fa-file-excel"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="customer">
      <modal-answer-addquestions id="modal-answer" :customer="customer" />
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import Paginate from 'vuejs-paginate';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import modalAnswerAddquestions from '@/components/molecules/modal-answer-addquestions';
import api from '../../../services/api';
import idxChips from '../../molecules/idx-chips';
import dropdownCategories from '../../molecules/dropdown-categories';
import dropdownStatus from '../../molecules/dropdown-status';
import EventBus from '../../../eventBus';

export default {
  components: {
    idxChips,
    dropdownCategories,
    modalAnswerAddquestions,
    dropdownStatus,
    Paginate,
  },

  props: ['isAnswerMenu'],

  data: () => ({
    displayFilterOptions: false,
    filterOptions: [
      { value: null, text: 'Escolha o filtro' },
      { value: 'profile', text: 'Perfil' },
      { value: 'status', text: 'Status' },
      { value: 'category', text: 'Categoria' },
      { value: 'responsible', text: 'Responsável' },
      { value: 'notification', text: 'Notificação' },
      { value: 'comemnt', text: 'Comentário' },
      { value: 'anonymous', text: 'Anônimo' },
      { value: 'treatmentTags', text: 'Tags Tratativas' },
      { value: 'audio', text: 'Áudio' },
      { value: 'sentiment', text: 'sentiment' },
      { value: 'partialAnswer', text: 'Resposta parcial' },
      {value: 'recordedAudio', text: 'Aúdio gravado'}
    ],
    filterSelectedOptions: [],
    filterSelected: null,
    filterValueSelected: null,
    statusSelect: { value: null, text: null },
    profileSelect: { value: null, text: null },
    categorySelected: { value: null, text: null },
    responsibleSelected: { value: null, text: null },
    notificationSelected: { value: null, text: null },
    subTagSelected: { value: null, text: null },
    lastContactStatus: { value: null, text: null },
    audioSelected: { value: null, text: null },
    partialAnswerSelected: { value: null, text: null },
    recordedAudioSelected: { value: null, text: null },
    sentimentSelected: { value: null, text: null },
    tagFilterAddQuestion: { value: null, text: null },
    profileOptions: [],
    statusOptions: [],
    categoryOptions: [],
    responsibleOptions: [],
    tagOptions: [],
    audioOptions: [],
    partialAnswerOptions: [],
    recordedAudioOptions: [],
    sentimentOptions: [],
    userAuth: null,
    active: false,
    limit: 10,
    options: [],
    fields: [],
    filter: null,
    typingTimer: null,
    sortBy: null,
    sortDesc: null,
    selectComments: null,
    grade: null,
    turnOffTheLight: false,
    commentEdited: null,
    loadingDownloadIconXls: false,
    loadingDownloadIconCsv: false,
    isGolCompany: false,
    isEnjoeiCompany: false,
    isRiachueloCompany: false,
    actionCategories: [],
    filterSubCategorySelected: null,
    filterSubTagSelected: null,
    filterOptionsTag: [],
    filterOptionsSubCategory: [],
    filterOptionsSubTag: [],
    subCategoryOptions: [],
    subTagOptions: [],
    subCategorySelected: { value: null, text: null },
    channelSelected: { value: null, text: null },
    channelOptions: [],
    commentOptions: [],
    anonymousOptions: [],
    commentSelected: { value: null, text: null },
    anonymousSelected: { value: null, text: null },
    tagSelected: { value: null, text: null },
    filterType: 'controlId', // default
    filterTypeOptions: [],
    customer: null,
    isLoading: false,
    isLoadingTranslate: false,
    translations: [
      { label: 'Portuguese', target: 'pt' },
      { label: 'English', target: 'en' },
      { label: 'Spanish', target: 'es' },
      { label: 'French', target: 'fr' },
      { label: 'German', target: 'de' },
    ],
    addQuestionTypeOptions: [
      { value: null, text: 'Selecione o tipo' },
      { value: 'REVIEWS', text: 'Review' },
      { value: 'CSAT', text: 'Escala 0 a 10' },
      { value: 'MULTIPLE', text: 'Multipla escolha' },
      { value: 'NPS', text: 'Nps' },
      { value: 'LIKERT', text: 'Likert' },
      { value: 'LIKE/DISLIKE', text: 'Like/Dislike' },
      { value: 'EMOTION', text: 'Emotion' },
      { value: 'CES', text: 'Ces 1 a 5' },
    ],
    addQuestionSelected: null,
    listAddQuestionsOptions: [],
    conditionalSelected: null,
    gradeSelected: null,
    listDefaultConditional: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Maior que', value: 'biggerThen' },
      { text: 'Maior ou igual a', value: 'greaterOrEqualTo' },
      { text: 'Menor que', value: 'lessThan' },
      { text: 'Menor ou igual a', value: 'lessThanOrEqualTo' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    listConditionals: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Maior que', value: 'biggerThen' },
      { text: 'Maior ou igual a', value: 'greaterOrEqualTo' },
      { text: 'Menor que', value: 'lessThan' },
      { text: 'Menor ou igual a', value: 'lessThanOrEqualTo' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    listGrades: [],
    optionsCriterion: [
      { text: 'Igual a', value: 'equal' },
      { text: 'Diferente de', value: 'different' },
      { text: 'Contém', value: 'contains' },
    ],
    optionsRules: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Maior que', value: 'biggerThen' },
      { text: 'Maior ou igual a', value: 'greaterOrEqualTo' },
      { text: 'Menor que', value: 'lessThan' },
      { text: 'Menor ou igual a', value: 'lessThanOrEqualTo' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    optionsRulesMultiple: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    optionsLikeEmotion: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
    ],
    listOptionsMultipleChoice: [{ text: 'Selecione', value: null }],
    optionSelected: null,
    listSubOptionsMultipleChoice: [{ text: 'Selecione', value: null }],
    subOptionSelected: null,
  }),

  computed: {
    ...mapState('treatments', ['answer', 'loading', 'allActions', 'summary']),
    ...mapState('settings', ['companyCategories']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('treatments', ['page', 'fromDetails']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('companies', ['company']),
  },

  methods: {
    ...mapActions('companies', ['recalculateNps']),
    ...mapActions('settings', ['getCategories', 'getAllUsers']),
    ...mapActions('calendar', ['setDates']),
    ...mapActions('treatments', [
      'deleteCategory',
      'setAnswers',
      'editCommentAnswer',
      'disableAnswer',
    ]),

    getAnswers() {
      this.updateTable();
    },

    applyFiltersUrlConditional() {
      this.replaceQueryParams({ conditional: this.conditionalSelected });
      this.gradeSelected = null;
    },

    returnNameWithEllipsis(text) {
      const texts = text.split(';');
      const words = texts[0].split(' ');
      if (words.length > 5) {
        const newText = words.slice(0, 5).join(' ');
        return `${newText} ...; ${texts[1]};${texts[2]} `;
      }

      return text;
    },

    returnNameAddQuestion() {
      for (let i = 0; i < this.listAddQuestionsOptions.length; i += 1) {
        if (
          this.listAddQuestionsOptions[i].value === this.addQuestionSelected
        ) {
          return this.listAddQuestionsOptions[i].text;
        }
      }

      return this.addQuestionSelected;
    },

    returnTranslateConditional(conditionalSelected) {
      let conditional = '';
      switch (conditionalSelected) {
        case 'equal':
          if (this.$i18n.locale === 'br') {
            conditional = 'igual';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'equal';
          } else {
            conditional = 'igual';
          }
          break;
        case 'biggerThen':
          if (this.$i18n.locale === 'br') {
            conditional = 'Maior que';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Bigger then';
          } else {
            conditional = 'Más grande que';
          }
          break;
        case 'greaterOrEqualTo':
          if (this.$i18n.locale === 'br') {
            conditional = 'Maior ou igual a';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Greater Or Equal To';
          } else {
            conditional = 'Mayor qué o igual a';
          }
          break;
        case 'lessThan':
          if (this.$i18n.locale === 'br') {
            conditional = 'Menor que';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Less than';
          } else {
            conditional = 'Menos que';
          }
          break;
        case 'lessThanOrEqualTo':
          if (this.$i18n.locale === 'br') {
            conditional = 'Menor ou igual a';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Less than or equal to';
          } else {
            conditional = 'Menos que o igual a';
          }
          break;
        case 'differentThan':
          if (this.$i18n.locale === 'br') {
            conditional = 'Diferente de';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Different than';
          } else {
            conditional = 'Diferente de';
          }
          break;
        case 'different':
          if (this.$i18n.locale === 'br') {
            conditional = 'Diferente';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'Different';
          } else {
            conditional = 'Diferente';
          }
          break;
        case 'contains':
          if (this.$i18n.locale === 'br') {
            conditional = 'contém';
          } else if (this.$i18n.locale === 'us') {
            conditional = 'contains';
          } else {
            conditional = 'contém';
          }
          break;
        default:
          break;
      }

      return conditional;
    },

    applyFiltersUrlGrade() {
      this.replaceQueryParams({ grade: this.gradeSelected });

      let secondFilter = `${this.returnTranslateConditional(
        this.conditionalSelected,
      )}`;
      let thirdFilter = `${this.gradeSelected}`;

      if (!this.conditionalSelected) {
        secondFilter = this.optionSelected ? this.optionSelected : '';
      }

      if (!this.gradeSelected) {
        thirdFilter = this.subOptionSelected ? this.subOptionSelected : '';
      }

      this.tagFilterAddQuestion = {
        text: `${this.returnNameAddQuestion(
          this.addQuestionSelected,
        )}; ${secondFilter}; ${thirdFilter}`,
        value: `${this.addQuestionSelected}-${this.conditionalSelected}-${this.gradeSelected}`,
      };

      this.getAnswers();
    },

    getOptionsConditional() {
      if (this.filterValueSelected === 'MULTIPLE') {
        this.listConditionals = this.optionsRulesMultiple;
      } else if (
        this.filterValueSelected === 'EMOTION' ||
        this.filterValueSelected === 'LIKE/DISLIKE'
      ) {
        this.listConditionals = this.optionsLikeEmotion;
      } else {
        this.listConditionals = this.listDefaultConditional;
      }
    },

    getValuesGradeOptions() {
      if (this.filterValueSelected === 'REVIEWS') {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: '1 estrela', value: 1 },
          { text: '2 estrelas', value: 2 },
          { text: '3 estrelas', value: 3 },
          { text: '4 estrelas', value: 4 },
          { text: '5 estrelas', value: 5 },
        ];
      } else if (
        this.filterValueSelected === 'CSAT' ||
        this.filterValueSelected === 'NPS'
      ) {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: '0', value: '0' },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 },
          { text: '4', value: 4 },
          { text: '5', value: 5 },
          { text: '6', value: 6 },
          { text: '7', value: 7 },
          { text: '8', value: 8 },
          { text: '9', value: 9 },
          { text: '10', value: 10 },
        ];
      } else if (this.filterValueSelected === 'LIKE/DISLIKE') {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: 'Dislike (Negativo)', value: '0' },
          { text: 'Like (Positivo)', value: 1 },
        ];
      } else if (this.filterValueSelected === 'EMOTION') {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: 'Carinha triste', value: '0' },
          { text: 'Carinha feliz', value: 1 },
        ];
      } else if (this.filterValueSelected === 'CES') {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 },
          { text: '4', value: 4 },
          { text: '5', value: 5 },
        ];
      } else if (
        this.filterValueSelected === 'LIKERT' ||
        this.filterValueSelected === 'LIKERT/EMOTION'
      ) {
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: 'Muito Satisfeito', value: 5 },
          { text: 'Satisfeito', value: 4 },
          { text: 'Indiferente', value: 3 },
          { text: 'Insatisfeito', value: 2 },
          { text: 'Muito Insatisfeito', value: 1 },
        ];
      } else if (this.filterValueSelected === 'MULTIPLE') {
        // faz requisição enviando o questionId para o back-end
        // back-end deve retornar as respostas das perguntas
        this.listGrades = [
          { text: 'Selecione o valor', value: null },
          { text: 'Não', value: 'Não' },
          { text: 'Poderia melhorar', value: 'Poderia melhorar' },
          { text: 'Nada a dizer.', value: 'Nada a dizer.' },
        ];
      }
    },

    async getOptionsFilterByQuestionType() {
      this.conditionalSelected = null;
      this.gradeSelected = null;

      if (this.filterValueSelected !== 'MULTIPLE') {
        this.getValuesGradeOptions();
        this.getOptionsConditional();
      } else {
        this.optionSelected = null;
        this.listOptionsMultipleChoice = [];
        this.listOptionsMultipleChoice.push({
          value: null,
          text: 'Selecione uma opção',
        });

        const resp = await api.get(
          `addquestion/${this.addQuestionSelected}/options`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              actionId:
                this.myActionsIds.length === 0
                  ? null
                  : this.myActionsIds.join(','),
              groupId: this.actionGroupData._id
                ? this.actionGroupData._id
                : null,
            },
          },
        );

        this.listOptionsMultipleChoice.push(...resp.data.choices);
      }

      this.replaceQueryParams({ question: this.returnNameAddQuestion(
        this.addQuestionSelected,
      )});

      this.replaceQueryParams({ iAddQuestion: this.addQuestionSelected });
    },

    async getSubOptions() {
      this.subOptionSelected = null;
      this.listSubOptionsMultipleChoice = [];
      this.listSubOptionsMultipleChoice.push({
        value: null,
        text: 'Selecione uma sub opção',
      });

      const resp = await api.get(
        `/addquestion/${this.addQuestionSelected}/subOptions`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id ? this.actionGroupData._id : null,
            optionText: this.optionSelected,
          },
        },
      );

      this.listSubOptionsMultipleChoice.push(...resp.data.subChoices);

      // if (resp.data.subChoices.length === 0) {
      //   this.applyFiltersUrlGrade();
      // }

      this.applyFiltersUrlGrade();
    },

    async translate(feedback, target, index) {
      if (feedback) {
        this.isLoadingTranslate = true;
        const response = await api.get(
          `/translate?text=${feedback}&target=${target}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.isLoadingTranslate = false;

        if (response && response.data && response.data.translatedText) {
          this.answer[index].translatedFeedback = response.data.translatedText;
        }
      }
    },
    setFilterType(value) {
      this.filterType = value;
    },

    async loadCustomer(answerId) {
      const icon = document.getElementById(`icon_${answerId}`);
      const spinner = document.getElementById(`spinner_${answerId}`);

      icon.style.display = 'none';
      spinner.style.display = 'inline-block';

      this.isLoading = true;

      const answer = await api.get(
        `/answer/${this.userAuth.companyId}/${answerId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.customer = answer.data;
      this.isLoading = false;

      icon.style.display = 'inline-block';
      spinner.style.display = 'none';
      setTimeout(() => {
        this.$bvModal.show('modal-answer');
      }, 300);
    },

    async handleFilterSubCategory() {
      const index = this.filterOptionsSubCategory.findIndex(
        (el) => el.value === this.filterSubCategorySelected,
      );

      const text = this.filterOptionsSubCategory[index].text;
      const value = this.filterOptionsSubCategory[index].value;

      this.subCategorySelected.text = text;
      this.subCategorySelected.value = value;

      await this.updateTable();
    },

    async handleFilterSubTag() {
      const index = this.filterOptionsSubTag.findIndex(
        (el) => el.value === this.filterSubTagSelected,
      );

      const text = this.filterOptionsSubTag[index].text;
      const value = this.filterOptionsSubTag[index].value;

      this.subTagSelected.text = text;
      this.subTagSelected.value = value;

      await this.updateTable();
    },

    async getSubCategory(value) {
      this.subCategoryOptions = [
        {
          value: null,
          text: 'Subcategoria',
        },
      ];

      const response = await api.get('/answer/categories-subcategories', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          idCategory: value,
        },
      });

      response.data.forEach((el) => {
        this.subCategoryOptions.push({
          value: el._id.toString(),
          text: el.name,
          categoryGroupId: el.categoryGroupId,
        });
      });

      this.filterOptionsSubCategory = this.subCategoryOptions;
    },

    async getTags() {
      this.tagOptions = [
        {
          value: null,
          text: 'Selecione uma tag',
        },
      ];

      const response = await api.get('/answer/tags', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      response.data.forEach((el) => {
        this.tagOptions.push({
          value: el._id.toString(),
          text: el.name,
        });
      });

      this.filterOptionsTag = this.tagOptions;
    },

    async getSubTags(value) {
      this.subTagOptions = [
        {
          value: null,
          text: 'Selecione uma subtag',
        },
      ];

      const response = await api.get('/answer/tags-subtags', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          idTag: value,
        },
      });

      response.data.forEach((el) => {
        this.subTagOptions.push({
          value: el._id.toString(),
          text: el.name,
          tagGroupId: el.tagGroupId,
        });
      });

      this.filterOptionsSubTag = this.subTagOptions;
    },

    async handleFilter() {
      this.filterValueSelected = null;
      this.filterSelectedOptions = [];

      if (this.filterSelected) {
        switch (this.filterSelected) {
          case 'category':
            if (this.myActionsIds.length !== 0 && this.actionGroupData._id) {
              this.getCategoryGroupAction(
                this.myActionsIds,
                this.actionGroupData._id,
              );
            } else if (this.myActionsIds.length !== 0) {
              this.getCategoryGroupAction(this.myActionsIds, null);
            } else if (this.actionGroupData._id) {
              this.getCategoryGroupAction(null, this.actionGroupData._id);
            } else {
              this.filterSelectedOptions = this.categoryOptions;
            }
            break;
          case 'status':
            this.filterSelectedOptions = this.statusOptions;
            break;
          case 'profile':
            this.filterSelectedOptions = this.profileOptions;
            break;
          case 'responsible':
            this.filterSelectedOptions = this.responsibleOptions;
            break;
          case 'notification':
            this.filterSelectedOptions = this.notificationOptions;
            break;
          case 'channel':
            this.filterSelectedOptions = this.channelOptions;
            break;
          case 'comment':
            this.filterSelectedOptions = this.commentOptions;
            break;
          case 'anonymous':
            this.filterSelectedOptions = this.anonymousOptions;
            break;
          case 'treatmentTags':
            this.filterSelectedOptions = this.tagOptions;
            break;
          case 'audio':
            this.filterSelectedOptions = this.audioOptions;
            break;
          case 'partialAnswer':
            this.filterSelectedOptions = this.partialAnswerOptions;
            break;
          case 'recordedAudio':
            this.filterSelectedOptions = this.recordedAudioOptions;
            break;
          case 'typeAddQuestion':
            this.filterSelectedOptions = this.addQuestionTypeOptions;
            break;
          case 'sentiment':
            this.filterSelectedOptions = this.sentimentOptions;
            break;
          default:
            break;
        }

        this.displayFilterOptions = true;
      } else {
        this.displayFilterOptions = false;
      }
    },

    async handleFilterValue() {
      if (this.filterSelected && this.filterValueSelected) {
        const index = this.filterSelectedOptions.findIndex(
          (el) => el.value === this.filterValueSelected,
        );

        const text = this.filterSelectedOptions[index].text;

        switch (this.filterSelected) {
          case 'category':
            this.categorySelected.value = this.filterValueSelected;
            this.categorySelected.text = text;

            this.getSubCategory(this.filterValueSelected);
            break;
          case 'status':
            this.statusSelect.value = this.filterValueSelected;
            this.statusSelect.text = text;
            break;
          case 'profile':
            this.profileSelect.value = this.filterValueSelected;
            this.profileSelect.text = text;
            break;
          case 'responsible':
            this.responsibleSelected.value = this.filterValueSelected;
            this.responsibleSelected.text = text;
            break;
          case 'notification':
            this.notificationSelected.value = this.filterValueSelected;
            this.notificationSelected.text = text;
            break;
          case 'channel':
            this.channelSelected.value = this.filterValueSelected;
            this.channelSelected.text = text;
            break;
          case 'comment':
            this.commentSelected.value = this.filterValueSelected;
            this.commentSelected.text = text;
            break;
          case 'anonymous':
            this.anonymousSelected.value = this.filterValueSelected;
            this.anonymousSelected.text = text;
            break;
          case 'audio':
            this.audioSelected.value = this.filterValueSelected;
            this.audioSelected.text = text;
            break;
          case 'partialAnswer':
            this.partialAnswerSelected.value = this.filterValueSelected;
            this.partialAnswerSelected.text = text;
            break;
          case 'recordedAudio':
            this.recordedAudioSelected.value = this.filterValueSelected;
            this.recordedAudioSelected.text = text;
            break;
          case 'sentiment':
            this.sentimentSelected.value = this.filterValueSelected;
            this.sentimentSelected.text = text;
            break;
          case 'treatmentTags':
            this.tagSelected.value = this.filterValueSelected;
            this.tagSelected.text = text;

            this.getSubTags(this.filterValueSelected);
            break;
          case 'typeAddQuestion':
            this.addQuestionSelected = null;
            this.gradeSelected = null;
            this.conditionalSelected = null;
            this.tagFilterAddQuestion.value = null;
            this.tagFilterAddQuestion.text = null;
            this.listAddQuestionsOptions = [];
            this.replaceQueryParams({ typeAddQuestion: undefined });
            this.replaceQueryParams({ question: undefined });
            this.replaceQueryParams({ conditional: undefined });
            this.replaceQueryParams({ grade: undefined });
            this.replaceQueryParams({ iAddQuestion: undefined });
            this.getListAddQuestions();
            break;
          default:
            break;
        }

        this.replaceQueryParams({
          [this.filterSelected]: this.filterValueSelected,
        });

        await this.updateTable();
      }
    },

    async getListAddQuestions() {
      let filterTypeAddQuestionSelected = this.filterValueSelected;

      if (this.filterValueSelected === 'LIKE/DISLIKE') {
        filterTypeAddQuestionSelected = 'LIKEeDISLIKE';
      }

      const resp = await api.get(
        `addquestion/${filterTypeAddQuestionSelected}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id ? this.actionGroupData._id : null,
          },
        },
      );

      this.getValuesGradeOptions();
      this.getOptionsConditional();

      this.listAddQuestionsOptions.push({
        text: 'Selecione uma pergunta',
        value: null,
      });
      this.listAddQuestionsOptions.push(...resp.data.listAddQuestion);
    },

    async handleJustComments(checked) {
      this.selectComments = checked;
      this.replaceQueryParams({ just_comments: checked ? true : null });
      await this.updateTable();
    },

    async removeFilter(filter) {
      switch (filter) {
        case 'category':
          this.categorySelected.value = null;
          this.categorySelected.text = null;
          break;
        case 'subCategory':
          this.subCategorySelected.value = null;
          this.subCategorySelected.text = null;
          break;
        case 'status':
          this.statusSelect.value = null;
          this.statusSelect.text = null;
          break;
        case 'lastStatus':
          this.lastContactStatus.value = null;
          this.lastContactStatus.text = null;
          this.$router.replace({
            path: this.$route.path,
            query: { ...this.$route.query, laststatus: undefined },
          });

          this.$router.replace({
            path: this.$route.path,
            query: { ...this.$route.query, monitoringreport: undefined },
          });

          break;
        case 'profile':
          this.profileSelect.value = null;
          this.profileSelect.text = null;
          break;
        case 'responsible':
          this.responsibleSelected.value = null;
          this.responsibleSelected.text = null;
          break;
        case 'notification':
          this.notificationSelected.value = null;
          this.notificationSelected.text = null;
          break;
        case 'channel':
          this.channelSelected.value = null;
          this.channelSelected.text = null;
          break;
        case 'comment':
          this.commentSelected.value = null;
          this.commentSelected.text = null;
          break;
        case 'anonymous':
          this.anonymousSelected.value = null;
          this.anonymousSelected.text = null;
          break;
        case 'audio':
          this.audioSelected.value = null;
          this.audioSelected.text = null;
          break;
        case 'partialAnswer':
          this.partialAnswerSelected.value = null;
          this.partialAnswerSelected.text = null;
          break;
        case 'recordedAudio':
          this.recordedAudioSelected.value = null;
          this.recordedAudioSelected.text = null;
          break;
        case 'sentiment':
          this.sentimentSelected.value = null;
          this.sentimentSelected.text = null;
          break;
        case 'tag':
          this.tagSelected.value = null;
          this.tagSelected.text = null;
          break;
        case 'subTag':
          this.subTagSelected.value = null;
          this.subTagSelected.text = null;
          break;
        case 'typeAddQuestion-conditional-grade':
          this.tagFilterAddQuestion.value = null;
          this.tagFilterAddQuestion.text = null;
          this.conditionalSelected = null;
          this.gradeSelected = null;
          this.optionSelected = null;
          this.subOptionSelected = null;
          this.addQuestionSelected = null;
          this.filterValueSelected = null;
          this.replaceQueryParams({ typeAddQuestion: undefined });
          this.replaceQueryParams({ question: undefined });
          this.replaceQueryParams({ conditional: undefined });
          this.replaceQueryParams({ grade: undefined });
          this.replaceQueryParams({ iAddQuestion: undefined });
          break;
        default:
          break;
      }

      this.replaceQueryParams({ [filter]: undefined });

      await this.updateTable();
    },

    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem Nome';
    },

    checkUserData(anonymous, profile, value) {
      if (anonymous || profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },

    async updateTable() {
      this.$store.state.treatments.loading = true;

      await this.setAnswers({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        queryParams: {
          actionId:
            this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          page: this.page,
          limit: this.limit,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          filter: this.filter,
          filterType: this.filterType,
          ih1:
            this.myHierarchies1.length === 0
              ? null
              : this.myHierarchies1.join(','),
          ih2:
            this.myHierarchies2.length === 0
              ? null
              : this.myHierarchies2.join(','),
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          selectComments: this.selectComments,
          // grade: this.grade,
          metric: this.myMetric,
          profile: this.profileSelect.value,
          status: this.statusSelect.value,
          groupId: this.actionGroupData._id,
          category: this.categorySelected.value,
          subCategory: this.subCategorySelected.value,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorFilter: (this.$route.query.nbi && this.$route.query.indicator) ? this.$route.query.indicator : null,
          indicatorFilterValue: (this.$route.query.nbi && this.$route.query.indicatorValue) ? this.$route.query.indicatorValue : null,
          indicatorRange: this.indicatorData.range,
          responsible: this.responsibleSelected.value,
          notification: this.notificationSelected.value,
          audio: this.audioSelected.value,
          partialAnswer: this.partialAnswerSelected.value,
          recordedAudio: this.recordedAudioSelected.value,
          channel: this.channelSelected.value,
          comment: this.commentSelected.value,
          anonymous: this.anonymousSelected.value,
          tag: this.tagSelected.value,
          subTag: this.subTagSelected.value,
          lastContactStatus: this.lastContactStatus.value,
          questionId: this.addQuestionSelected ? this.addQuestionSelected : this.$route.query.iAddQuestion,
          grade: null,
          gradeSelected: this.gradeSelected ? this.gradeSelected : null,
          conditionalSelected: this.conditionalSelected ? this.conditionalSelected : this.$route.query.conditional,
          typeAddQuestion: this.filterValueSelected
            ? this.filterValueSelected
            : this.$route.query.typeAddQuestion,
          optionText: this.optionSelected,
          subOptionText: this.subOptionSelected,
          sentiment: this.sentimentSelected.value
        },
      });
      this.$store.state.treatments.loading = false;
    },

    async exportData(fileType, csvSeparator, reportType) {
      // checks if the total docs to download is greater then 500k.
      if (this.summary.total > 500000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }

      if (fileType === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else if (fileType === 'csv') {
        this.loadingDownloadIconCsv = true;
      }

      if (csvSeparator === 'comma') {
        csvSeparator = ',';
      }
      if (csvSeparator === 'pipe') {
        csvSeparator = '|';
      }

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        if (fileType === 'xlsx' && reportType === 'categories') {
          await api.get(
            `${this.apiServerlessDownloads}/category/download/${this.userAuth.companyId}/xlsx`,
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
              params: {
                startDate: this.calendarDates.start,
                endDate: this.calendarDates.end,
                filter: this.filter,
                filterType: this.filterType,
                actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : JSON.stringify(this.myActionsIds),
                ih1:
                  this.myHierarchies1.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies1),
                ih2:
                  this.myHierarchies2.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies2),
                profile: this.profileSelect.value,
                status: this.statusSelect.value,
                groupId: this.actionGroupData._id,
                category: this.categorySelected.value,
                subCategory: this.subCategorySelected.value,
                metric: this.myMetric,
                indicator: this.indicatorName,
                indicatorValue: this.indicatorData.value,
                indicatorRange: this.indicatorData.range,
                responsible: this.responsibleSelected.value,
                channel: this.channelSelected.value,
                comment: this.commentSelected.value,
                selectComments: this.selectComments,
                csvSeparator,
                language: this.$i18n.locale,
              },
            },
          );
        } else if (fileType === 'xlsx' && reportType === 'analytics') {
          await api.get(
            `${this.apiServerlessDownloads}/analytics/download/${this.userAuth.companyId}/xlsx`,
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
              params: {
                startDate: this.calendarDates.start,
                endDate: this.calendarDates.end,
                filter: this.filter,
                filterType: this.filterType,
                actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : JSON.stringify(this.myActionsIds),
                ih1:
                  this.myHierarchies1.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies1),
                ih2:
                  this.myHierarchies2.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies2),
                groupId: this.actionGroupData._id,
                metric: this.myMetric,
                indicator: this.indicatorName,
                indicatorValue: this.indicatorData.value,
                indicatorRange: this.indicatorData.range,
                language: this.$i18n.locale,
              },
            },
          );
        } else {
          await api.get(
            `${this.apiServerlessDownloads}/answers/download/${this.userAuth.companyId}/${fileType}`,
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
              params: {
                startDate: this.calendarDates.start,
                endDate: this.calendarDates.end,
                filter: this.filter,
                filterType: this.filterType,
                actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : JSON.stringify(this.myActionsIds),
                ih1:
                  this.myHierarchies1.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies1),
                ih2:
                  this.myHierarchies2.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies2),
                profile: this.profileSelect.value,
                status: this.statusSelect.value,
                groupId: this.actionGroupData._id,
                category: this.categorySelected.value,
                subCategory: this.subCategorySelected.value,
                metric: this.myMetric,
                indicator: this.indicatorName,
                indicatorValue: this.indicatorData.value,
                indicatorRange: this.indicatorData.range,
                npsByIndicatorReportFilter: (this.$route.query.nbi && this.$route.query.indicator) ? this.$route.query.indicator : null,
                npsByIndicatorReportFilterValue: (this.$route.query.nbi && this.$route.query.indicatorValue) ? this.$route.query.indicatorValue : null,
                responsible: this.responsibleSelected.value,
                channel: this.channelSelected.value,
                comment: this.commentSelected.value,
                selectComments: this.selectComments,
                csvSeparator,
                language: this.$i18n.locale,
                questionId: this.addQuestionSelected,
                gradeSelected: this.gradeSelected,
                conditionalSelected: this.conditionalSelected,
                typeAddQuestion: this.filterValueSelected
                  ? this.filterValueSelected
                  : null,
                optionText: this.optionSelected,
                subOptionText: this.subOptionSelected,
              },
            },
          );
        }

        swal({
          title: this.$t('answers.donwload.title'),
          text: this.$t('answers.donwload.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.ops'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (fileType === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },

    async editComment(item, index) {
      const $input = document.getElementById(
        `comment-feedback-eddited-${index}`,
      );
      const comment = $input.value;
      await this.editCommentAnswer({
        token: this.userAuth.token,
        answerId: item._id,
        data: {
          comment,
          author: this.userAuth.name,
        },
      });
      await this.updateTable();
    },

    searchByFilter() {
      if (
        this.filter !== '' &&
        this.filter !== null &&
        this.filterType !== null
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
      if (this.filter === '') {
        this.filter = null;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.updateTable();
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${hour}`;
    },

    gradeFormat(grade) {
      if (
        this.myMetric === 'nps-0-10' ||
        this.myMetric === 'csat-0-10(media)'
      ) {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.myMetric === 'like-dislike') {
        if (grade === 1) {
          return 'promoters';
        } else if (grade === 0) {
          return 'detractors';
        }
        return 'invalid';
      } else if (
        this.myMetric === 'nps-1-5' ||
        this.myMetric === 'ces-1-5' ||
        this.myMetric === 'csat-1-5' ||
        this.myMetric === 'csat-1-5(media)' ||
        this.myMetric === '5-stars'
      ) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      }
      return 'invalid';
    },

    async getCompanyCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: null,
          },
        });
        this.actionCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },

    async removeCategorySubCategory(event, answer, categoryId, subCategoryId) {
      let operation = null;
      answer.categories.splice(answer.categories.indexOf(categoryId), 1);

      if (event.target.checked === true) {
        operation = 'add';
      } else {
        operation = 'delete';
      }

      await api.patch(
        `/category-subcategory/${answer._id}`,
        {
          subCategoryId,
          categoryId,
          operation,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async deleteCategoryByX(answer, categoryId) {
      answer.categories.splice(answer.categories.indexOf(categoryId), 1);

      try {
        await api.patch(
          `/answer-categories/${answer._id}`,
          {
            operation: 'delete',
            categoryId,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } catch (error) {
        window.console.log(error);
      }
    },

    teste() {
      if (this.isAnswerMenu) {
        this.fields = [
          { key: 'controlId', label: this.$t('answers.answerTable.labels.id') },
          {
            key: 'date',
            label: this.$t('answers.answerTable.labels.date'),
            sortable: true,
          },
          {
            key: 'review',
            label: this.$t('answers.answerTable.labels.grade'),
            sortable: true,
          },
          { key: 'name', label: this.$t('answers.answerTable.labels.client') },
          {
            key: 'comment',
            label: this.$t('answers.answerTable.labels.comment'),
            class: 'w280',
          },
          {
            key: 'category',
            label: this.$t('answers.answerTable.labels.category'),
          },
          {
            key: 'tags',
            label: this.$t('answers.answerTable.labels.tags'),
          },
          {
            key: 'details',
            label: this.$t('answers.answerTable.labels.options'),
            class: 'w100',
          },
        ];
      } else {
        this.fields = [
          {
            key: 'controlId',
            label: this.$t('treatments.treatmentTable.labels.id'),
          },
          {
            key: 'date',
            label: this.$t('treatments.treatmentTable.labels.date'),
            sortable: true,
          },
          {
            key: 'review',
            label: this.$t('treatments.treatmentTable.labels.grade'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('treatments.treatmentTable.labels.client'),
          },
          {
            key: 'comment',
            label: this.$t('treatments.treatmentTable.labels.comment'),
            class: 'w280',
          },
          {
            key: 'responsible',
            label: this.$t('treatments.treatmentTable.labels.responsible'),
          },
          {
            key: 'category',
            label: this.$t('treatments.treatmentTable.labels.category'),
          },
          {
            key: 'tags',
            label: this.$t('answers.answerTable.labels.tags'),
          },
          {
            key: 'status',
            label: this.$t('treatments.treatmentTable.labels.status'),
          },
          {
            key: 'days',
            label: this.$t('treatments.treatmentTable.labels.days'),
          },
          {
            key: 'details',
            label: this.$t('treatments.treatmentTable.labels.options'),
            class: 'w100',
          },
        ];
      }
    },

    hideMenu() {
      this.turnOffTheLight = false;
    },

    enableEditComment() {
      this.turnOffTheLight = true;
    },

    deleteAnswer(id, actionId) {
      const divDeleteMotive = document.createElement('div');

      const label = document.createElement('label');
      label.innerHTML = 'Motivo:';
      label.classList = 'col-12 text-left p-0 m-1';
      label.style.color = 'rgba(0,0,0,.64)';
      label.style.fontSize = '16px';

      const textarea = document.createElement('textarea');
      textarea.rows = '5';
      textarea.classList = 'col-12 border form-control';

      divDeleteMotive.appendChild(label);
      divDeleteMotive.appendChild(textarea);

      swal({
        title: this.$t('answers.deleteAnswer.title'),
        text: this.$t('answers.deleteAnswer.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
        content: divDeleteMotive,
      }).then((deleted) => {
        if (deleted) {
          swal(this.$t('answers.removeSuccess'), {
            icon: 'success',
          });
          const arr = [];
          this.answer.forEach((el) => {
            if (el._id !== id) {
              arr.push(el);
            }
          });
          this.$store.state.treatments.answer = arr;
          this.disableAnswer({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            data: {
              answerId: id,
              reason: textarea.value,
              actionId,
            },
          });
        }
      });
    },

    async getStatus() {
      const response = await api.get(`treatments-status`, {
        headers: { 'x-access-token': this.userAuth.token },
      });

      this.statusOptions = [];

      response.data.forEach((el) => {
        this.statusOptions.push({ value: el.value, text: el.text });
      });
    },

    changeFields() {
      if (this.isAnswerMenu) {
        this.fields = [
          {
            key: 'controlId',
            label: this.$t('answers.answerTable.labels.id'),
          },
          {
            key: 'date',
            label: this.$t('answers.answerTable.labels.date'),
            sortable: true,
          },
          {
            key: 'review',
            label:
              this.myMetric === 'like-dislike'
                ? 'Avaliação'
                : this.$t('answers.answerTable.labels.grade'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('answers.answerTable.labels.client'),
          },
          {
            key: 'comment',
            label: this.$t('answers.answerTable.labels.comment'),
            class: 'w280',
          },
          {
            key: 'category',
            label: this.$t('answers.answerTable.labels.category'),
          },
          {
            key: 'tags',
            label: this.$t('answers.answerTable.labels.tags'),
          },
          {
            key: 'details',
            label: this.$t('answers.answerTable.labels.options'),
            class: 'w100',
          },
        ];
      } else {
        this.fields = [
          {
            key: 'controlId',
            label: this.$t('treatments.treatmentTable.labels.id'),
          },
          {
            key: 'date',
            label: this.$t('treatments.treatmentTable.labels.date'),
            sortable: true,
          },
          {
            key: 'review',
            label:
              this.myMetric === 'like-dislike'
                ? 'Avaliação'
                : this.$t('answers.answerTable.labels.grade'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('treatments.treatmentTable.labels.client'),
          },
          {
            key: 'comment',
            label: this.$t('treatments.treatmentTable.labels.comment'),
            class: 'w280',
          },
          {
            key: 'responsible',
            label: this.$t('treatments.treatmentTable.labels.responsible'),
          },
          {
            key: 'category',
            label: this.$t('treatments.treatmentTable.labels.category'),
          },
          {
            key: 'tags',
            label: this.$t('answers.answerTable.labels.tags'),
          },
          {
            key: 'status',
            label: this.$t('treatments.treatmentTable.labels.status'),
          },
          {
            key: 'days',
            label: this.$t('treatments.treatmentTable.labels.days'),
          },
          {
            key: 'details',
            label: this.$t('treatments.treatmentTable.labels.options'),
            class: 'w100',
          },
        ];
      }
    },

    changeLabels() {
      this.filterTypeOptions = [
        {
          text: this.$t('answers.filterTypeOptions.id'),
          value: 'controlId',
        },
        {
          text: this.$t('answers.filterTypeOptions.clientId'),
          value: 'clientId',
        },
        {
          text: this.$t('answers.filterTypeOptions.email'),
          value: 'email',
        },
        {
          text: this.$t('answers.filterTypeOptions.name'),
          value: 'name',
        },
        {
          text: this.$t('answers.filterTypeOptions.phone'),
          value: 'phone',
        },
        {
          text: this.$t('answers.filterTypeOptions.feedback'),
          value: 'feedback',
        },
      ];

      this.filterOptions = [
        { value: null, text: this.$t('answers.filterOptions.select') },
        { value: 'profile', text: this.$t('answers.filterOptions.profile') },
        { value: 'status', text: this.$t('answers.filterOptions.status') },
        { value: 'category', text: this.$t('answers.filterOptions.category') },
        {
          value: 'responsible',
          text: this.$t('answers.filterOptions.responsible'),
        },
        {
          value: 'notification',
          text: this.$t('answers.filterOptions.notification'),
        },
        {
          value: 'channel',
          text: this.$t('answers.filterOptions.channel'),
        },
        {
          value: 'comment',
          text: this.$t('answers.filterOptions.comments'),
        },
        {
          value: 'anonymous',
          text: this.$t('answers.filterOptions.anonymous'),
        },
        {
          value: 'treatmentTags',
          text: this.$t('answers.filterOptions.treatmentTags'),
        },
        {
          value: 'audio',
          text: this.$t('answers.filterOptions.audio'),
        },
        {
          value: 'partialAnswer',
          text: this.$t('answers.filterOptions.partial'),
        },
        {
          value: 'typeAddQuestion',
          text: this.$t('answers.filterOptions.addQuestion'),
        },
        {
          value: 'sentiment',
          text: this.$t('answers.filterOptions.sentiment'),
        },
        {
          value: 'recordedAudio',
          text: this.$t('answers.filterOptions.recordedAudio'),
        },
      ];

      let promotersText = '';
      let passivesText = '';
      let detractorsText = '';

      if (
        this.myMetric.indexOf('nps') >= 0 ||
        this.myMetric === 'csat-0-10(media)'
      ) {
        promotersText = this.$t('answers.profileSelect.promoters');
        passivesText = this.$t('answers.profileSelect.neutral');
        detractorsText = this.$t('answers.profileSelect.detractors');
      } else if (this.myMetric.indexOf('ces') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('csat') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('stars') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('like-dislike') >= 0) {
        promotersText = 'Like';
        detractorsText = 'Dislike';
      }

      this.profileOptions = [
        { value: null, text: this.$t('answers.profileSelect.select') },
        { value: 'all', text: this.$t('answers.profileSelect.all') },
        { value: 'detractors', text: detractorsText },
        { value: 'passives', text: passivesText },
        { value: 'promoters', text: promotersText },
      ];

      if(this.myMetric.indexOf('like-dislike') >= 0) {
        this.profileOptions.splice(3, 1);
      }

      this.categoryOptions = [
        { value: null, text: this.$t('answers.categorySelect.select') },
        { value: 'all', text: this.$t('answers.categorySelect.all') },
        { value: 'empty', text: this.$t('answers.categorySelect.empty') },
      ];

      this.subCategoryOptions = [
        {
          value: null,
          text: 'Selecione uma subcategoria',
        },
      ];

      this.tagOptions = [{ value: null, text: 'Selecione a tag' }];

      this.subTagOptions = [
        {
          value: null,
          text: 'Selecione uma subtag',
        },
      ];

      this.getStatus();
      this.getResponsibles();

      this.notificationOptions = [
        { value: null, text: this.$t('answers.notificationSelect') },
        {
          value: 'noviewed',
          text: this.$t('answers.notificationSelects.noViewed'),
        },
        {
          value: 'viewed',
          text: this.$t('answers.notificationSelects.viewed'),
        },
      ];

      this.channelOptions = [
        { value: null, text: this.$t('answers.channelSelect.select') },
        { value: 'all', text: this.$t('answers.channelSelect.all') },
        {
          value: 'email',
          text: this.$t('answers.channelSelect.email'),
        },
        {
          value: 'link',
          text: this.$t('answers.channelSelect.link'),
        },
        {
          value: 'manual',
          text: this.$t('answers.channelSelect.manual'),
        },
        {
          value: 'qrcode',
          text: this.$t('answers.channelSelect.qrcode'),
        },
        {
          value: 'sms',
          text: this.$t('answers.channelSelect.sms'),
        },
        {
          value: 'whatsapp',
          text: this.$t('answers.channelSelect.whatsapp'),
        },
        {
          value: 'widget',
          text: this.$t('answers.channelSelect.widget'),
        },
      ];
      this.commentOptions = [
        { value: null, text: this.$t('answers.commentsSelect.select') },
        { value: 'all', text: this.$t('answers.commentsSelect.all') },
        {
          value: 'withComments',
          text: this.$t('answers.commentsSelect.withComments'),
        },
        {
          value: 'noComments',
          text: this.$t('answers.commentsSelect.noComments'),
        },
      ];
      this.anonymousOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'false',
          text: this.$t('answers.anonymousSelect.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.anonymousSelect.yes'),
        },
      ];

      this.audioOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'false',
          text: this.$t('answers.anonymousSelect.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.anonymousSelect.yes'),
        },
      ];

      this.recordedAudioOptions = [
        { value: null, text: this.$t('answers.recordedAudio.select') },
        { value: 'all', text: this.$t('answers.recordedAudio.all') },
        {
          value: 'false',
          text: this.$t('answers.recordedAudio.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.recordedAudio.yes'),
        },
      ];

      this.partialAnswerOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'false',
          text: this.$t('answers.anonymousSelect.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.anonymousSelect.yes'),
        },
      ];

      this.sentimentOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'positive',
          text: this.$t('answers.sentiment.positive'),
        },
        {
          value: 'neutral',
          text: this.$t('answers.sentiment.neutral'),
        },
        {
          value: 'negative',
          text: this.$t('answers.sentiment.negative'),
        },
      ];
    },

    async getResponsibles() {
      const response = await api.get('treatments/responsible-users', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          ih1:
            this.myHierarchies1.length === 0
              ? null
              : this.myHierarchies1.join(','),
          ih2:
            this.myHierarchies2.length === 0
              ? null
              : this.myHierarchies2.join(','),
        },
      });

      let users = [];

      if (response.data && response.data.length) {
        users = response.data.map((a) => {
          return {
            value: a._id,
            text: a.name,
          };
        });
      }

      this.responsibleOptions = [
        { value: null, text: this.$t('answers.responsibleSelect') },
        {
          value: 'none',
          text: this.$t('answers.answersDetails.treatments.nobody'),
        },
      ].concat(users);
    },

    async handleRemoveCategory(answerIndex, categoryId, categoryIndex) {
      swal({
        title: this.$t('answers.deleteCategory.title'),
        text: this.$t('answers.deleteCategory.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal(this.$t('answers.categoryDelSuccess'), {
            icon: 'success',
          });
          this.answer[answerIndex].categories.splice(categoryIndex, 1);
          const subCategories = [];
          this.answer[answerIndex].subCategories.forEach((el) => {
            if (el.mainCategoryId !== categoryId) {
              subCategories.push(el);
            }
          });
          this.answer[answerIndex].subCategories = subCategories;
          await api.patch(
            `/answer-categories/${this.answer[answerIndex]._id}`,
            {
              operation: 'delete',
              categoryId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    isCategoryIA(answerIndex, id) {
      if (this.answer[answerIndex].categoriesIA) {
        for (
          let i = 0;
          i < this.answer[answerIndex].categoriesIA.length;
          i += 1
        ) {
          if (id === this.answer[answerIndex].categoriesIA[i]) {
            return true;
          }
        }
      }
      return false;
    },
    isSubCategoryIA(answerIndex, id) {
      if (this.answer[answerIndex].subCategoriesIA) {
        for (
          let i = 0;
          i < this.answer[answerIndex].subCategoriesIA.length;
          i += 1
        ) {
          if (id === this.answer[answerIndex].subCategoriesIA[i]) {
            return true;
          }
        }
      }
      return false;
    },

    async handleRemoveSubCategory(
      answerIndex,
      categoryId,
      subCategoryId,
      subCategoryIndex,
    ) {
      this.answer[answerIndex].subCategories.splice(subCategoryIndex, 1);

      await api.patch(
        `/category-subcategory/${this.answer[answerIndex]._id}`,
        {
          subCategoryId,
          categoryId,
          operation: 'delete',
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async getCategoryGroupAction(actionsIds, actionGroupId) {
      try {
        const response = await api.get('/categories-groups', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              actionsIds && actionsIds.length > 0 ? actionsIds.join(',') : null,
            actionGroupId,
          },
        });

        const categoriesGroups = response.data;

        this.filterSelectedOptions = [
          { value: null, text: this.$t('answers.categorySelect.select') },
          { value: 'all', text: this.$t('answers.categorySelect.all') },
          { value: 'empty', text: this.$t('answers.categorySelect.empty') },
        ];

        categoriesGroups.categories.forEach((el) => {
          if (el.active === true) {
            this.filterSelectedOptions.push({
              value: el._id.toString(),
              text: el.name,
            });
          }
        });
      } catch (error) {
        window.console.log(error);
      }
    },
    showComment(comment) {
      if (comment && comment.length > 255) {
        return `${comment.substr(0, 255)} ...`;
      }
      return comment;
    },
    showDays(item) {
      // If there is no starDate, we don't have howe to calculate solving period
      if (!item.treatments.startDate) {
        return 'N/A';
      }
      const startDate = new Date(item.treatments.startDate);
      let solvedDate;
      // If there is no solvedDate, calculates with current time
      if (item.treatments.solvedDate) {
        solvedDate = new Date(item.treatments.solvedDate);
      } else {
        solvedDate = new Date();
      }
      // If period < 1 day, returns period in time
      const diffTime = solvedDate - startDate;
      const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));
      if (diffDays > 0) {
        return `${diffDays} d`;
      }
      return `${new Date(diffTime).toISOString().substr(11, 2)} h`;
    },
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.page = 1;
      this.updateTable();
    },

    myActionId: function watchmyActionId() {
      this.page = 1;
      this.updateTable();
    },

    myActionsIds: function watchMyActionsIds() {
      this.page = 1;
      this.updateTable();
    },

    calendarDates: function watchCalendarDates() {
      this.page = 1;
      this.updateTable();
    },

    myIh1: function watchMyIh1() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.page = 1;
      this.updateTable();
    },

    myIh2: function watchMyIh2() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.page = 1;
      this.updateTable();
    },

    myMetric: function watchMyMetric() {
      this.page = 1;
      this.updateTable();
      this.changeLabels();
      this.changeFields();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.page = 1;
      this.updateTable();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.page = 1;
      this.updateTable();
    },
  },

  mounted() {
    // checks if the company is Gol or Enjoei or Riachuelo
    if (this.userAuth.companyId === '618930fd630b4d6b6d2b3b32') {
      this.isGolCompany = true;
    }
    if (this.userAuth.companyId === '63e3b50648a1640013c99f6b') {
      this.isEnjoeiCompany = true;
    }
    if (this.userAuth.companyId === '608847fadef1b07e809ad539') {
      this.isRiachueloCompany = true;
    }

    if (this.userAuth.companyId === '608847fadef1b07e809ad539') {
      this.isRiachueloCompany = true;
    }

    this.changeFields();

    EventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });

    EventBus.$on('changedAction', () => {
      this.handleFilter();
    });

    EventBus.$on('resetFilterCategory', () => {
      this.filterSelected = null;
      this.filterValueSelected = null;
      this.displayFilterOptions = false;
    });

    EventBus.$on('filter-status', async (ev) => {
      const index = this.statusOptions.findIndex((el) => el.value === ev);

      if (index >= 0) {
        this.statusSelect.value = this.statusOptions[index].value;
        this.statusSelect.text = this.statusOptions[index].text;
      }

      this.updateTable();
    });
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.$store.state.treatments.loading = false;

    this.changeLabels();

    this.changeFields();

    this.teste();

    await Promise.all([
      this.getCompanyCategories(),
      /*
      this.getCategories({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
      }),
      */
      // this.getResponsibles(),
    ]);

    this.getSubTags();
    this.getTags();

    if (this.$route.query.monitoringreport === 'true') {
      this.lastContactStatus.value = this.$route.query.laststatus;
      this.lastContactStatus.text = this.$route.query.laststatus;
    }

    this.actionCategories.forEach((el) => {
      if (el.active === true) {
        this.options.push(el);

        this.categoryOptions.push({
          value: el._id.toString(),
          text: el.name,
          categoryGroupId: el.categoryGroupId,
        });
      }
    });
    if (this.fromDetails) {
      this.fromDetails = false;
    } else {
      this.page = 1;
    }

    if (parseInt(this.$route.query.grade, 10) + 1) {
      this.grade = this.$route.query.grade;
    }

    if (this.$route.query.profile) {
      const index = this.profileOptions.findIndex(
        (el) => el.value === this.$route.query.profile,
      );

      if (index >= 0) {
        this.profileSelect.value = this.profileOptions[index].value;
        this.profileSelect.text = this.profileOptions[index].text;
      }
    }

    if (this.$route.query.category) {
      const index = this.categoryOptions.findIndex(
        (el) => el.value === this.$route.query.category,
      );

      if (index >= 0) {
        this.categorySelected.value = this.categoryOptions[index].value;
        this.categorySelected.text = this.categoryOptions[index].text;
      }
    }

    if (this.$route.query.status) {
      const index = this.statusOptions.findIndex(
        (el) => el.value === this.$route.query.status,
      );

      if (index >= 0) {
        this.statusSelect.value = this.statusOptions[index].value;
        this.statusSelect.text = this.statusOptions[index].text;
      }
    }

    if (this.$route.query.responsible) {
      const index = this.responsibleOptions.findIndex(
        (el) => el.value === this.$route.query.responsible,
      );

      if (index >= 0) {
        this.responsibleSelected.value = this.responsibleOptions[index].value;
        this.responsibleSelected.text = this.responsibleOptions[index].text;
      }
    }

    if (this.$route.query.notification) {
      const index = this.notificationOptions.findIndex(
        (el) => el.value === this.$route.query.notification,
      );

      if (index >= 0) {
        this.notificationSelected.value = this.notificationOptions[index].value;
        this.notificationSelected.text = this.notificationOptions[index].text;
      }
    }

    if (this.$route.query.channel) {
      const index = this.channelOptions.findIndex(
        (el) => el.value === this.$route.query.channel,
      );

      if (index >= 0) {
        this.channelSelected.value = this.channelOptions[index].value;
        this.channelSelected.text = this.channelOptions[index].text;
      }
    }
    if (this.$route.query.comment) {
      const index = this.commentOptions.findIndex(
        (el) => el.value === this.$route.query.comment,
      );

      if (index >= 0) {
        this.commentSelected.value = this.commentOptions[index].value;
        this.commentSelected.text = this.commentOptions[index].text;
      }
    }

    if (this.$route.query.just_comments) {
      this.selectComments = true;
    }

    if (this.$route.query.recordedAudio) {
      this.recordedAudioSelected.value = this.$route.query.recordedAudio.toString();
      this.recordedAudioSelected.text = this.$t('answers.recordedAudio.yes');
    }

    if (
      this.$route.query.typeAddQuestion &&
      this.$route.query.conditional &&
      this.$route.query.grade
    ) {
      this.tagFilterAddQuestion = {
        text: `${this.$route.query.question}; ${this.returnTranslateConditional(
          this.$route.query.conditional,
        )}; ${this.$route.query.grade}`,
        value: `${this.addQuestionSelected}-${this.conditionalSelected}-${this.gradeSelected}`,
      };
    }

    this.updateTable();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.addquestion-select {
  // max-width: 160px;
  // widows: 160px;
  width: 50%
}

.header-filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .search-answers {
    display: flex;
    flex-direction: row;
    max-width: 300px;

    input {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }

    button {
      height: 38px;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
}

.filters-options-area {
  display: flex;
  flex-direction: row;
}

.categories-area {
  max-height: 150px;
  overflow: auto;
}

.switch-box {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.switch-box span {
  font-size: 16px;
}

.closebtn {
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}

.search-answers {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.filter-type {
  display: flex;
  flex-direction: row;
  max-width: 150px;
  margin-right: 10px;
}

.filters-area {
  display: flex;
  flex-direction: row;

  .tag {
    background: $primary;
    padding: 4px 8px;
    color: $white;
    border-radius: 8px;
    margin-right: 8px;

    .remove {
      cursor: pointer;
    }
  }
}

.flag-category-close {
  cursor: pointer;
  &:hover {
    color: rgb(240, 235, 235);
  }
}

a {
  cursor: pointer;
}

.flag-category-text {
  text-transform: lowercase;
}

.edit-comment-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
}

.save-comment {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.feedback-edited-icon {
  font-size: 12px;
  color: $gray;
}
.table-icons {
  color: $primary;
  padding-left: 25px;
  font-size: 20px;
  svg {
    &:hover {
      color: #46b41e;
    }
  }
}
.select-categories {
  height: 200px;
  width: 100px;
  background-color: red;
  display: none;
}
.user-info {
  color: rgb(133, 131, 131);
}
.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}
.xls:hover {
  color: #1dc86e;
}
.flag-grade-promoters {
  background-color: #28a745;
}
.flag-grade-detractors {
  background-color: #dc3545;
}
.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}
.flag-grade-invalid {
  background-color: #c1c1c1;
}
.edit-comment-area {
  display: flex;
  flex-direction: row;
}
.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.comment {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.comment .turn-off-the-lights {
  position: fixed;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  background-color: rgba(0, 0, 0, 0.04);
  top: 0;
  left: 0;
  z-index: 99999;
  transition: all 0.2s linear;
}
.comment .light-box {
  width: 600px;
  height: 400px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  padding: 16px;
}
.comment .fade-enter-active,
.comment .fade-leave-active {
  transition: opacity 0.2s;
}
.comment .fade-enter,
.comment .fade-leave-to {
  opacity: 0;
}
</style>

<style>
.thumbs-up-answer {
  color: #64b64d;
  font-size: 40px;
}

.thumbs-down-answer {
  color: red;
  font-size: 40px;
}

.pagination-area-answers .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-answers a {
  outline: none;
}
textarea {
  resize: none;
}
.ar-icon {
  margin-top: -10px;
}
.dropdown-csv {
  border: 0px;
  padding: 0px;
}

.w280 {
  min-width: 280px !important;
}
.w100 {
  min-width: 100px !important;
}

.translate img {
  width: 20px;
  cursor: pointer;
}

.translate-list-item {
  border-bottom: solid 1px #f5f2f2;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  min-width: 140px;
}

.translate-list-item:hover {
  background: #e1e1e1;
}

.close {
  font-size: 20px;
  padding-left: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatment-table/index.vue